import {skipToken} from '@reduxjs/toolkit/query'

import {pipelinesApi} from '../services/pipelinesApi'

import usePipelineParentProjectId from './usePipelineParentProjectId'

export function useIsParentKotlinDsl(): boolean {
  const parentProjectId = usePipelineParentProjectId()
  const {data: effectiveConfig} =
    pipelinesApi.endpoints.getEffectiveVersionedSettingsConfig.useQuery(
      parentProjectId ? {projectId: parentProjectId} : skipToken,
    )
  return effectiveConfig?.config?.format === 'kotlin'
}
